import React, { useState, useEffect, useMemo } from "react";
import "./Book.css";

// First set (default images)
import Img1A from "../images/vw.jpg";
import Img2A from "../images/Bakkie.jpeg";
import Img3A from "../images/The-BMW-i8-Roadster-I15-5.jpg";
import Img4A from "../images/minibus4.jpg";
import Img5A from "../images/White boat.jpeg";

// Second set (alternates)
import Img1B from "../images/red sedan audi.jpg";
import Img2B from "../images/red suv.jpg";
import Img3B from "../images/sportscar2.jpg";
import Img4B from "../images/Benz Mini bus.png";
import Img5B from "../images/boat1.jpg";

const Book = () => {
  const [indices, setIndices] = useState([0, 0, 0, 0, 0]);

  // Memoize imageSets so it doesn't change on every render
  const imageSets = useMemo(() => [
    [Img1A, Img1B],
    [Img2A, Img2B],
    [Img3A, Img3B],
    [Img4A, Img4B],
    [Img5A, Img5B],
  ], []);   // Empty dependency array because imported images never change

  // Preload all images for faster switching
  useEffect(() => {
    imageSets.flat().forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [imageSets]);

  // Auto slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setIndices((prev) => prev.map((i) => (i + 1) % 2));
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="service-component__space" id="Book">
      <div className="heading">
        <h1 className="heading">Book</h1>
        <p className="heading p__color">
          Our services cover both interior and exterior car washes.
        </p>
      </div>

      <div className="container">
        <div className="row">
          {/* Card 1: Sedan/Hatchback */}
          <div className="col__3">
            <a href="#Contact">
              <div className="service__box pointer">
                <div className="icon">
                  <div className="project__img__box slideshow">
                    <img
                      src={imageSets[0][indices[0]]}
                      alt="Sedan/Hatchback"
                      className="project__img"
                      loading="eager"
                      fetchPriority="high"
                      decoding="sync"
                    />
                  </div>
                </div>
                <h1 className="service__text">Sedan/hatch back (R400)</h1>
                <p className="p service__text p__color">
                  Comprehensive wash for Sedans, including exterior wash, interior vacuum, window cleaning, and tire shine.
                </p>
              </div>
            </a>
          </div>

          {/* Card 2: SUV/Bakkie */}
          <div className="col__3">
            <a href="#Contact">
              <div className="service__box pointer">
                <div className="icon">
                  <div className="project__img__box slideshow">
                    <img
                      src={imageSets[1][indices[1]]}
                      alt="SUV/Bakkie"
                      className="project__img"
                      loading="eager"
                      fetchPriority="high"
                      decoding="sync"
                    />
                  </div>
                </div>
                <h1 className="service__text">SUV/Bakkie (R500)</h1>
                <p className="p service__text p__color">
                  Specialized wash for bukkies and SUVs, including exterior cleaning, bed cleaning, and complete interior detailing.
                </p>
              </div>
            </a>
          </div>

          {/* Card 3: Sports Car */}
          <div className="col__3">
            <a href="#Contact">
              <div className="service__box pointer">
                <div className="icon">
                  <div className="project__img__box slideshow">
                    <img
                      src={imageSets[2][indices[2]]}
                      alt="Sports Car"
                      className="project__img"
                      loading="eager"
                      fetchPriority="high"
                      decoding="sync"
                    />
                  </div>
                </div>
                <h1 className="service__text">Sports Car (R500)</h1>
                <p className="p service__text p__color">
                  Comprehensive wash tailored for sports cars, including exterior wash, interior vacuum, window cleaning, and tire shine.
                </p>
              </div>
            </a>
          </div>

          {/* Card 4: Mini Bus */}
          <div className="col__3">
            <a href="#Contact">
              <div className="service__box pointer">
                <div className="icon">
                  <div className="project__img__box slideshow">
                    <img
                      src={imageSets[3][indices[3]]}
                      alt="Mini Bus"
                      className="project__img"
                      loading="eager"
                      fetchPriority="high"
                      decoding="sync"
                    />
                  </div>
                </div>
                <h1 className="service__text">Mini Bus (R600)</h1>
                <p className="p service__text p__color">
                  Comprehensive wash for mini buses, including exterior wash, interior vacuum, window cleaning, and tire shine.
                </p>
              </div>
            </a>
          </div>

          {/* Card 5: Boat */}
          <div className="col__3">
            <a href="#Contact">
              <div className="service__box pointer">
                <div className="icon">
                  <div className="project__img__box slideshow">
                    <img
                      src={imageSets[4][indices[4]]}
                      alt="Boat"
                      className="project__img"
                      loading="eager"
                      fetchPriority="high"
                      decoding="sync"
                    />
                  </div>
                </div>
                <h1 className="service__text">Boat (R950)</h1>
                <p className="p service__text p__color">
                  Comprehensive wash for boats, including exterior wash, interior vacuum (where applicable), window cleaning (if applicable), and hull shine.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;